import { defineComponent as _defineComponent } from 'vue'
import { onMounted, useContext } from '@nuxtjs/composition-api';
import 'tributejs/dist/tribute.css';
import { getAvatar, getWarRoomProfilePath } from '@/components/common/BravadoEditor/utils';
import { MENTIONS_CONTAINER_CLASS, MENTIONS_ITEM_CLASS } from '@/components/common/BravadoEditor/constants';
import { SearchUsersQuery } from '@/apollo/queries/SearchUsers.query';
import '@/components/common/BrvdMentions/styles.scss';
import debounce from '~/components/utils/debounce';


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomUserSelector',
  setup(__props) {

const LazyTributeUpload = () => import('tributejs');

const { app } = useContext();

async function fetchUsers(text: string, cb: Function) {
  if (text) {
    const { data } = await app.apolloProvider?.defaultClient.query({
      query: SearchUsersQuery,
      variables: {
        query: text,
        // @ts-ignore
        boostUserUsernames: document.activeElement.dataset.boostUsernames,
      },
    });

    cb(data.searchUsers);
  }
}

onMounted(() => {
  LazyTributeUpload().then(({ default: Tribute }) => {
    const tribute = new Tribute({
      containerClass: MENTIONS_CONTAINER_CLASS,
      selectClass: 'selected',
      itemClass: MENTIONS_ITEM_CLASS,
      // @ts-ignore
      menuContainer: document.querySelector('.layout--default'),
      // @ts-ignore
      selectTemplate({ original: { username } }) {
        return `<a data-mention-user-username="${username}" href="${getWarRoomProfilePath(
          username,
        )}" class="mention" contenteditable="false" target="_blank"><span>@${username}</span></a>`;
      },
      // @ts-ignore
      menuItemTemplate({ original: { warRoomAvatarUrl, username } }) {
        return getAvatar(warRoomAvatarUrl, username);
      },
      // @ts-ignore
      noMatchTemplate: '<span class="brvd-mentions__empty">No Match Found!<span>',
      lookup: 'username',
      fillAttr: 'username',
      allowSpaces: false,
      values: debounce(fetchUsers, 100),
      preventBlockInputByMenu: true,
      spaceSelectsMatch: true,
    });

    function handler(el: HTMLElement) {
      if (el.getAttribute('data-tributed')) {
        return;
      }
      tribute.attach(el);
      el.setAttribute('data-tributed', 'true');
    }

    document.addEventListener(
      'focus',
      // eslint-disable-next-line func-names
      function (e) {
        // @ts-ignore
        for (let target = e.target; target && target !== this; target = target.parentNode) {
          // @ts-ignore
          if (target.matches('[selectable][contenteditable]')) {
            // @ts-ignore
            handler.call(target, target, e);
            break;
          }
        }
      },
      true,
    );
  });
});

return { __sfc: true,LazyTributeUpload, app, fetchUsers }
}

})